import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  NgbModule,
  NgbDateAdapter,
  NgbDateNativeAdapter,
} from '@ng-bootstrap/ng-bootstrap';

import { pipes } from '../pipes';

@NgModule({
  declarations: [
    pipes,
  ],
  imports: [
    CommonModule,
    NgbModule,
  ],
  exports: [
    CommonModule,
    NgbModule,
    pipes,
  ],
  providers: [
    pipes,
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
  ],
})
export class PipesModule {}
